module.exports = __webpack_public_path__ + "static/media/boltIcon.e96caa94.svg";